export default function Skeleton() {
  return <div className='absolute left-0 top-0 h-[120px] w-full bg-white' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='flex h-full w-full items-center justify-between'>
                <div className='h-full w-[8%] animate-pulse rounded-l bg-gray-100'></div>
                <div className='h-full w-[75%] animate-pulse rounded bg-gray-100'></div>
                <div className='h-full w-[8%] animate-pulse rounded-r bg-gray-100'></div>
            </div>
        </div>;
}